import { Service } from "models/Service";

export class Forecast extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description: `Pronostico mundial clubes 2025 - Clarin.com`,
        keywords: '',
        title: `Pronostico mundial clubes 2025 - Clarin.com`,
        url: `pronostico-mundial-clubes-2025`, 
        extra: [],
      },
      section: "deportes",
      sectionName: "Deportes",
      template: "Forecast",
      title: `Pronostico mundial clubes 2025`,
      slug: "",
      titleHeader:"Pronostico mundial clubes 2025",
      widthFull: true,
      bannersOn: false,
      enableHeader: true,
      enableFooter: true,
      autorefresh: false
    });    
  }
  
  parseData = async (query, menu) => {
    let predictionId = query[1] || "";
    this.setTitle(`Pronosticos - Clarin.com`);
    // this.setBreadcrumb( [
    //   {
    //     title: `Pronostico mundial clubes 2025`,
    //     url: "/pronostico-mundial-clubes-2025",
    //   }
    // ]);
    this.setTitleHeader(`Pronostico mundial clubes 2025`);
    this.setTemplate("Forecast");
    this.setData({
      title: `Simulador del torneo Mundial de Clubes`,
      subTitle: `Clickeá sobre el equipo que te parece saldrá en 1° lugar. Luego elegí el que termina 2°. Si querés corregir, “limpiá” tu voto y arrancá de nuevo.`,
      iframe: predictionId ? `https://sorteomundial.ole.com.ar/index.html#/clarin/pronostico-mundial-clubes-2025/${predictionId}` : "https://sorteomundial.ole.com.ar/index.html#/clarin/pronostico-mundial-clubes-2025",
      height: "100%",
    });
  }

}